import React, { useState, useEffect } from 'react';
import { Form, Radio, message, Modal, Spin, Typography } from 'antd';
import { Selection } from '../../../components/common';
import { network, generators, asserts } from '../../../utils';
import api from '../../../config/api';
import { isEmpty } from 'ramda';

const { Text } = Typography;

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

const { generatorArray } = generators;

export default Form.create()(({ form, currentMcu, onConfirm, onCancel }) => {
  const { getFieldDecorator, getFieldsValue, setFieldsValue } = form;
  const [transferMcus, setTransferMcus] = useState([]); // 批量转移的仓库
  const [transferVisible, setTransferVisible] = useState(false); // 批量转移弹窗
  const [transferLoading, setTransferLoading] = React.useState(false);
  const [batchTransferLoading, setBatchTransferLoading] = React.useState(false);
  const [stockList, setStockList] = React.useState([]);
  const [currentMcuName, setCurrentMcuName] = React.useState(null);

  useEffect(() => {
    setTransferVisible(true);
  }, []);

  useEffect(() => {
    fetchMcuList();
    fetchStockList();
  }, []);

  const fetchMcuList = async () => {
    setTransferLoading(true);
    const response = await network.get(api.orderCenter.detail.warehouse);
    setTransferLoading(false);
    if (!response.success) return [];
    if (!response.data.success) {
      message.error(response.data.message);
      return [];
    }
    const warehouse = generatorArray(response.data.data);
    if (currentMcu) {
      let currentMcuName = warehouse.filter((item) => item.aamcu === currentMcu);
      if (currentMcuName.length) {
        setCurrentMcuName(currentMcuName[0].mcdl01);
      }
    }
    setTransferMcus(warehouse);
  };

  const fetchStockList = async () => {
    setTransferLoading(true);
    const response = await network({
      url: api.stock.stockListBySelect,
      method: 'get',
    });
    if (response.success) {
      setTransferLoading(false);
      if (!response.data.success) {
        message.error(response.data.message);
        return;
      }
      const list = generators.generatorArray(response.data.data);
      const noStock = { ssCode: '-1', ssName: '无标识' };
      let newList = [noStock, ...list];
      setStockList(newList);
    }
  };

  // 批量转移取消
  const handleTransferCancel = () => {
    setTransferVisible(false);
    onCancel && onCancel();
  };
  // 批量转移确定
  const handleTransferConfirm = async () => {
    setBatchTransferLoading(true);
    const values = getFieldsValue();
    if (isEmpty(currentMcu)) {
      // 页面选择的是全部仓库时 仓库不存在时必须选择仓库
      if (!asserts.isExist(values.transferSpcomv)) {
        message.warn('请选择一个仓库');
        setBatchTransferLoading(false);
        return;
      }
    }
    let filterMcuList = transferMcus.filter((item) => item.aamcu === values.transferSpcomv);
    let filterStockList = stockList.filter((item) => item.ssCode === values.transferStockCode);
    onConfirm &&
      onConfirm({
        ...values,
        transferSpcomvName: filterMcuList.length ? filterMcuList[0].mcdl01 : null,
        transferStockName: filterStockList.length ? filterStockList[0].ssName : null,
      });
  };

  return (
    <Modal
      title="转移选项"
      visible={transferVisible}
      width={600}
      onCancel={handleTransferCancel}
      onOk={handleTransferConfirm}
      confirmLoading={batchTransferLoading}
    >
      <Spin spinning={transferLoading}>
        <Form {...formItemLayout}>
          <Form.Item label="当前所在">
            <Text>{currentMcuName ? currentMcuName : null}</Text>
          </Form.Item>
          <Form.Item label="转移至">
            {getFieldDecorator('transferSpcomv', { initialValue: currentMcu })(
              <Radio.Group>
                {transferMcus.map((item, index) => {
                  return (
                    <Radio value={item.aamcu} key={index}>
                      {item.mcdl01}
                    </Radio>
                  );
                })}
              </Radio.Group>,
            )}
          </Form.Item>
          <Form.Item label="标识">
            {getFieldDecorator('transferStockCode', {
              initialValue: null,
            })(
              <Selection
                source={stockList}
                style={{ width: 300 }}
                transfer={{ key: 'ssCode', name: 'ssName', code: 'ssCode' }}
                allowClear
                onChange={(value) => {
                  let newList = stockList.map((itm) => {
                    if (itm.ssCode === value) {
                      setFieldsValue({
                        transferStockCode: itm.checked ? null : value,
                      });
                      return {
                        ...itm,
                        checked: !itm.checked,
                      };
                    }
                    return itm;
                  });
                  setStockList(newList);
                }}
              />,
            )}
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
});
